import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constants/Endpoints/EndPoints";
import { FetchRequestHandler } from "../../utils/commonUtilities";

export const fetchPracticeStatus = createAsyncThunk(
    "fetchPracticeStatus",
     async (practiceId) => {
        const result = await FetchRequestHandler(
          "get",
          `${baseUrl}api/practices/${practiceId}/status`
        );
        return result;
      }
)

export const updatePracticeStatus = createAsyncThunk(
    "updatePracticeStatus",
     async ({practiceId, data}) => {
        const result = await FetchRequestHandler(
          "put",
          `${baseUrl}api/practices/${practiceId}/status`,
          data
        );
        return result;
      }
)

export const practiceDuplicateCheck = createAsyncThunk(
  "practiceDuplicateCheck",
  async (query) => {
    const result = await FetchRequestHandler(
      "get",
      `${baseUrl}api/practices?field=all&page-number=1&page-size=1&query=${query}&view=search`
    );
    return result;
  }
);